import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { Field } from 'formik';

import FieldUtil from '../utils/FieldNames';

import '../../../../app/assets/stylesheets/rte_edit_payer.scss';

class CostRulesSection extends Component {
  displayValue(value) {
    if (_.isArray(value)) {
      return value.map(FieldUtil.transformName).join(',');
    }
    if (_.isString(value)) {
      return value;
    }
    return '---';
  }

  renderField({ isViewMode, path, fieldName }) {
    return (
      <Field
        name={`${path}.${fieldName}`}
        render={({ field, form }) => (
          <div className="input_div">
            <input
              {...field}
              onChange={this.props.handleChange}
              disabled={isViewMode}
              className="accum_subkey_field_input"
            />
            <span className="error_container">
              {_.get(form.touched, field.name) &&
                FieldUtil.transformErrorMessage(_.get(form.errors, field.name))
              }
            </span>
          </div>
        )}
      />
    );
  }

  renderPaymentMethodsFields() {
    return (
      <div>
        <div className="cost_rules">
          <b>Payment Methods</b>
        </div>
        {FieldUtil.paymentMethodFields.map((method, i) => (
          <div className="cost_rules" key={i}>
            <p className="payment_method_field" key={i}>{FieldUtil.transformName(method)}</p>
          </div>
        ))}
      </div>
    );
  }

  renderPaymentMethodsValues() {
    const isViewMode = this.props.mode !== 'edit';
    return (
      <div className="payment_methods">
        <div className="cost_rules"><p>&nbsp;</p></div>
        {FieldUtil.paymentMethodFields.map((method, i) => (
          <div className="cost_rules" key={i}>
            {this.renderField({
              isViewMode,
              fieldName: method,
              path:      'payer_config.payer_config_settings.cost_rules.payment_methods'
            })}
          </div>
        ))}
      </div>
    );
  }

  renderSection() {
    const isViewMode = this.props.mode !== 'edit';
    return (
      <div className="cost_rules_section">
        <div className="fields">
          {FieldUtil.costRulesFields.map((costRuleField, i) => (
            <div key={i}>
              {costRuleField === 'payment_methods' ? this.renderPaymentMethodsFields()
                : (
                  <div className="cost_rules" key={i}>
                    <p><b>{FieldUtil.transformName(costRuleField)}</b></p>
                  </div>
                )}
            </div>
          ))}
        </div>
        <div className="field_values">
          {FieldUtil.costRulesFields.map((costRuleField, i) => (
            <div key={i}>
              {costRuleField === 'payment_methods' ? this.renderPaymentMethodsValues()
                : (
                  <div className="cost_rules" key={i}>
                    {this.renderField({ fieldName: costRuleField, isViewMode, path: 'payer_config.payer_config_settings.cost_rules' })}
                  </div>
                )}
            </div>
          ))}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderSection()}
      </div>
    );
  }
}

CostRulesSection.propTypes = {
  visibleSection: PropTypes.string,
  costRulesData:  PropTypes.object,
  mode:           PropTypes.string,
  handleChange:   PropTypes.func
};

export default CostRulesSection;
